// filepath: c:\Users\rafat\repo\Flaha\FlahaFast\client\src\components\ui\Select.tsx
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select as MUISelect,
  MenuItem,
  FormHelperText,
  styled,
  SelectChangeEvent
} from '@mui/material';

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectProps {
  /** Select label */
  label: string;
  /** Select options */
  options: SelectOption[];
  /** Helper text */
  helperText?: string;
  /** Error state */
  error?: boolean;
  /** Error text */
  errorText?: string;
  /** Full width */
  fullWidth?: boolean;
  /** Controlled value */
  value?: string | number;
  /** Change handler */
  onChange?: (event: SelectChangeEvent<string | number>) => void;
  /** Name attribute */
  name?: string;
  /** ID attribute */
  id?: string;
  /** Disabled state */
  disabled?: boolean;
  /** Multiple selection */
  multiple?: boolean;
  /** Required field */
  required?: boolean;
  /** Size variant */
  size?: 'small' | 'medium';
  /** Aria labelledby */
  'aria-labelledby'?: string;
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
  },
}));

export const Select: React.FC<SelectProps> = ({
  label,
  options,
  helperText,
  error = false,
  errorText,
  fullWidth = true,
  value,
  onChange,
  ...rest
}) => {
  const displayHelperText = error && errorText ? errorText : helperText;
  const labelId = `${label.toLowerCase().replace(/\s+/g, '-')}-label`;

  return (
    <StyledFormControl fullWidth={fullWidth} error={error}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <MUISelect
        labelId={labelId}
        value={value}
        onChange={onChange}
        label={label}
        variant="outlined"
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MUISelect>
      {displayHelperText && <FormHelperText>{displayHelperText}</FormHelperText>}
    </StyledFormControl>
  );
};

export default Select;
